import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Plane, Briefcase, Heart, Clock } from 'lucide-react';
import { useCases, services } from '../mock';
import { useI18n } from '../i18n';
import { Button } from '../components/ui/button';

const icons = { airport: Plane, business: Briefcase, events: Heart, hourly: Clock };

const Services = () => {
  const { t, lang } = useI18n();
  return (
    <div className="pt-[72px] bg-white">
      <section className="bg-black text-white py-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <p className="text-[11px] tracking-[0.4em] uppercase text-white/60">Services</p>
          <h1 className="font-serif text-5xl md:text-6xl mt-4 max-w-3xl">{t('usecases.title')}</h1>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 gap-10">
          {useCases.map(uc => {
            const Icon = icons[uc.id] || Plane;
            return (
              <div key={uc.id} className="group relative overflow-hidden">
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={uc.image} alt={uc.keyFr} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="py-6">
                  <div className="flex items-center gap-3 text-black/60 text-sm"><Icon className="w-4 h-4" /> <span className="tracking-[0.2em] uppercase text-xs">Service</span></div>
                  <h3 className="font-serif text-3xl mt-3">{lang === 'fr' ? uc.keyFr : uc.keyEn}</h3>
                  <p className="text-black/60 mt-3 leading-relaxed">{lang === 'fr' ? uc.descFr : uc.descEn}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="py-20 bg-[#f6f4f1]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <h2 className="font-serif text-4xl md:text-5xl">{t('fleet.title')}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
            {services.map(s => (
              <div key={s.id} className="bg-white">
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={s.image} alt={s.nameFr} className="w-full h-full object-cover" />
                </div>
                <div className="p-6">
                  <h3 className="font-serif text-2xl">{lang === 'fr' ? s.nameFr : s.nameEn}</h3>
                  <p className="text-black/50 text-xs uppercase tracking-widest mt-1">{s.pax} {t('fleet.pax')} • {s.luggage} {t('fleet.luggage')}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-12">
            <Link to="/contact">
              <Button className="bg-black hover:bg-black/85 text-white rounded-none h-12 px-8 text-sm tracking-[0.2em] uppercase">
                {t('cta.btn')} <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
